// Bug 26/50 · Helper riuso per parsare errori API in modo leggibile.
// FastAPI/Pydantic 422 restituisce:
//   { "detail": [ { "loc": ["body","title"], "msg": "field required", "type": "missing" } ] }
// FastAPI custom HTTPException restituisce:
//   { "detail": "Testo libero" }
// Altri errori (network, 500) → nessun body prevedibile.

const FIELD_IT = {
  title: "Titolo",
  description: "Descrizione",
  type: "Tipo",
  status: "Stato",
  priority: "Priorità",
  importance: "Importanza",
  urgency: "Urgenza",
  area_id: "Area",
  sub_area_id: "Sotto-area",
  project_id: "Progetto",
  due_date: "Scadenza",
  due_time: "Ora scadenza",
  scheduled_date: "Data programmata",
  scheduled_time: "Ora programmata",
  scheduled_duration_min: "Durata",
  recurrence_rule: "Ricorrenza",
  reminder_offsets_days: "Promemoria giorni",
  reminder_time: "Promemoria ora",
  linked_calendar_id: "Calendario",
  horizon: "Orizzonte",
  target_date: "Data target",
  category: "Categoria",
  objective_text: "Obiettivo",
  next_action_hint: "Prossima azione (nota)",
  email: "Email",
  password: "Password",
};

const MSG_IT = {
  missing: "obbligatorio",
  string_too_short: "troppo corto",
  string_too_long: "troppo lungo",
  value_error: "non valido",
  type_error: "tipo non valido",
  greater_than: "troppo basso",
  less_than: "troppo alto",
};

function _labelForType(errType, defaultMsg) {
  if (!errType) return defaultMsg || "non valido";
  // Pydantic v2 usa slug tipo "string_too_short.min_length"
  const base = String(errType).split(".")[0];
  return MSG_IT[base] || defaultMsg || "non valido";
}

/**
 * Estrae una stringa leggibile per l'utente dagli errori API.
 * Sempre restituisce una stringa non vuota.
 *
 * @param {*} err  Errore axios (o generic) oppure oggetto response.
 * @param {string} fallback Testo mostrato se non riesce a parsare nulla.
 * @returns {string}
 */
export function parseFieldErrors(err, fallback = "Errore durante il salvataggio") {
  const detail = err?.response?.data?.detail ?? err?.data?.detail ?? err?.detail;
  // Caso 1 · Pydantic 422 con array di errori
  if (Array.isArray(detail)) {
    if (detail.length === 0) return fallback;
    const parts = detail.slice(0, 3).map((e) => {
      const loc = Array.isArray(e.loc) ? e.loc : [];
      // Escludi il primo elemento ("body"/"query"/"path") per leggibilità
      const path = loc.length > 1 && ["body", "query", "path"].includes(loc[0])
        ? loc.slice(1)
        : loc;
      const fieldKey = path.length > 0 ? String(path[path.length - 1]) : "campo";
      const label = FIELD_IT[fieldKey] || fieldKey;
      const problem = _labelForType(e.type, e.msg);
      return `${label} ${problem}`;
    });
    return parts.join(" · ");
  }
  // Caso 2 · Custom HTTPException con detail stringa
  if (typeof detail === "string" && detail.trim().length > 0) return detail;
  // Caso 3 · axios error senza response (network)
  if (err?.message && !err?.response) {
    if (err.code === "ERR_NETWORK") return "Rete non disponibile · riprova";
    return err.message;
  }
  return fallback;
}

/**
 * Wrapper convenience per toast: parsa e ritorna già formattato.
 * (l'invocazione toast.error() resta a carico del chiamante per non
 * accoppiare questo helper a una libreria di toast specifica).
 */
export function fieldErrorMessage(err, fallback) {
  return parseFieldErrors(err, fallback);
}
